var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGnbHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home (9) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0138 4.04532C12.8331 3.11315 11.1669 3.11315 9.98616 4.04532L4.48616 8.38743C3.70547 9.00376 3.25 9.94365 3.25 10.9383V17.4999C3.25 19.2948 4.70507 20.7499 6.5 20.7499H8C8.13807 20.7499 8.25 20.638 8.25 20.4999V17.4999C8.25 15.9811 9.48122 14.7499 11 14.7499H13C14.5188 14.7499 15.75 15.9811 15.75 17.4999V20.4999C15.75 20.638 15.8619 20.7499 16 20.7499H17.5C19.2949 20.7499 20.75 19.2948 20.75 17.4999V10.9383C20.75 9.94365 20.2945 9.00376 19.5138 8.38743L14.0138 4.04532ZM9.05669 2.868C10.7824 1.50559 13.2176 1.50559 14.9433 2.868L20.4433 7.21011C21.5843 8.1109 22.25 9.48458 22.25 10.9383V17.4999C22.25 20.1232 20.1234 22.2499 17.5 22.2499H16C15.0335 22.2499 14.25 21.4664 14.25 20.4999V17.4999C14.25 16.8095 13.6904 16.2499 13 16.2499H11C10.3096 16.2499 9.75 16.8095 9.75 17.4999V20.4999C9.75 21.4664 8.9665 22.2499 8 22.2499H6.5C3.87665 22.2499 1.75 20.1232 1.75 17.4999V10.9383C1.75 9.48458 2.41569 8.1109 3.55669 7.2101L9.05669 2.868Z",
    fill: "#046C9C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGnbHome);
export default __webpack_public_path__ + "static/media/icon-gnb-home.af85dd62fd718ba8b183b2208c15e178.svg";
export { ForwardRef as ReactComponent };